import { CrudOperations } from '../enums/crud-operations.enum';

export const PERMISSIONS_DEFAULT = [
  {
    Type: 0,
    Name: 'PublicDataAccess',
    IsAllowed: false,
  },
  {
    Type: 100,
    Name: CrudOperations.Create,
    IsAllowed: false,
  },
  {
    Type: 101,
    Name: CrudOperations.Read,
    IsAllowed: false,
  },
  {
    Type: 102,
    Name: CrudOperations.Update,
    IsAllowed: false,
  },
  {
    Type: 103,
    Name: CrudOperations.Delete,
    IsAllowed: false,
  },

];
